module.exports = __webpack_public_path__ + "img/charity-campaign.0f65f88f.jpg";